
import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Youtube, GraduationCap } from 'lucide-react';
import { BRAND_NAME, CONTACT_EMAIL, WHATSAPP_NUMBER, LOCATION } from '../constants';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <GraduationCap className="h-8 w-8 text-blue-400" />
              <span className="text-2xl font-bold text-white">{BRAND_NAME}</span>
            </Link>
            <p className="text-sm leading-relaxed mb-6">
              EduZone is Pakistan's premier educational portal dedicated to providing free, high-quality notes for All Board (All Board) students. We empower learners with the tools they need to excel in their academic journeys.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="bg-slate-800 p-2 rounded-full hover:bg-blue-600 transition text-white"><Facebook size={18} /></a>
              <a href="#" className="bg-slate-800 p-2 rounded-full hover:bg-blue-600 transition text-white"><Twitter size={18} /></a>
              <a href="#" className="bg-slate-800 p-2 rounded-full hover:bg-blue-600 transition text-white"><Youtube size={18} /></a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/notes-hub" className="hover:text-blue-400 transition">Notes Hub</Link></li>
              <li><Link to="/subjects" className="hover:text-blue-400 transition">Subjects Hub</Link></li>
              <li><Link to="/exam-prep" className="hover:text-blue-400 transition">Exam Preparation Center</Link></li>
              <li><Link to="/faqs" className="hover:text-blue-400 transition">Frequently Asked Questions</Link></li>
              <li><Link to="/about" className="hover:text-blue-400 transition">About EduZone</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Classes</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/class/class-9" className="hover:text-blue-400 transition">Class 9 Notes</Link></li>
              <li><Link to="/class/class-10" className="hover:text-blue-400 transition">Class 10 Notes</Link></li>
              <li><Link to="/class/class-11" className="hover:text-blue-400 transition">1st Year Notes (HSSC-I)</Link></li>
              <li><Link to="/class/class-12" className="hover:text-blue-400 transition">2nd Year Notes (HSSC-II)</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contact Info</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin className="text-blue-400 h-5 w-5 shrink-0" />
                <span>{LOCATION}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-blue-400 h-5 w-5 shrink-0" />
                <span>{WHATSAPP_NUMBER}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-blue-400 h-5 w-5 shrink-0" />
                <span>{CONTACT_EMAIL}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-xs">
          <p>&copy; {new Date().getFullYear()} {BRAND_NAME}.pk. All Rights Reserved.</p>
          <div className="flex space-x-6">
            <Link to="/privacy-policy" className="hover:text-white transition">Privacy Policy</Link>
            <Link to="/disclaimer" className="hover:text-white transition">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
